import AddSkills from './add-skills';
import SkillVisualizer from './skill-visualizer';
import type { ProjectResponse } from '@/types';
import type React from 'react';

interface SkillsProps {
  projectDetails: ProjectResponse;
  isReadOnly?: boolean;
}

const Skills: React.FC<SkillsProps> = ({
  projectDetails,
  isReadOnly
}) => {

  return (
    <>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold tracking-tight">Project Skills Profile</h2>
            <p className="text-sm text-muted-foreground">Comprehensive overview of skills required for this project</p>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto">
            <AddSkills projectDetails={projectDetails} isReadOnly={isReadOnly} />
          </div>
        </div>

        <SkillVisualizer
          projectId={projectDetails.id}
          project_id={projectDetails.project_id}
        />
      </div>
    </>
  );
};

export default Skills;
